// Retourne les initiales d'un utilisateur
// -> fullname : string > Prénom + nom
function getUserInitials(fullname) {
  return fullname.split(" ").map((n) => n[0]).join("");
}

export default {
  getUserInitials,
}
export {
  getUserInitials,
}



// WEBPACK FOOTER //
// ./src/utils/user.js